import * as R from 'ramda'
import { COMPLETE_STEPS } from 'app/store/actions/setupSteps.actions'
import effects from 'app/effects/effects'

export const setupStepsMiddleware = (store) => (next) => (action) => {
  if (R.equals(action.type, COMPLETE_STEPS)) {
    // This may cause a little computation, so i move this inside if block to avoid a lot computations.
    const completdStepId = R.compose(
      R.prop('id'),
      R.find(R.propSatisfies(R.equals(action.id), 'id')),
      R.path(['setupSteps', 'steps']),
    )(store.getState())

    if (completdStepId)
      return effects.apis
        .completeAccountSetupStep(completdStepId)
        .then(() => next(action))
  }
  return next(action)
}
